import { gql } from '@apollo/client'
import { USER_FRAGMENT } from '../fragments'

export const UPDATE_USER = gql`
  mutation UpdateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      user {
        ...User
      }
    }
  }
  ${USER_FRAGMENT}
`
